import React, { Component } from 'react'
import { func } from 'prop-types'
import { view } from '@risingstack/react-easy-state'
import { translate } from 'react-i18next'
import { NavigationButtons } from '../../ui/buttons/NavigationButtons'
import { stores } from '../../../stores'
import { validateReferences } from '../../../utilities/validators'
import { Input } from '../../ui/inputs/Input'
import { validation } from '../validation'
import { InquiryTypes } from '../../../constants/InquiryTypes'
import { pushGtmTrigger } from '../../../utilities/window'

class AddressStepComponent extends Component {
  constructor () {
    super()
    this.state = {
      errors: []
    }
  }
  async componentWillMount () {}

  componentDidMount () {
    pushGtmTrigger('enter_address_v2')
  }

  handleSubmit () {
    let { errors } = validateReferences(this.refs)
    // Remove duplicates - only used for disponibilities errors
    errors = errors.filter((x, i, a) => a.indexOf(x) === i)
    this.setState({ errors })
    if (!errors.length) {
      this.props.next()
    }
  }

  render () {
    const { t, previous } = this.props
    return (<div>
      <div className='demande__container no_max_width --with-padding-bottom'>
        <label style={{fontWeight: 600}} className={'form__label'}>
          <h3 className='demande-form__h3'>{t(stores.inquiry.type === InquiryTypes.VISIT ? 'common:fields:visits_address' : 'common:fields:intervention_address')}</h3>
        </label>
        <div className='demande-form__container'>
          <Input bold label={t('common:fields:adress')} name='address' ref='address' rules={validation.address} value={stores.inquiry.address.address} onChange={(value) => { stores.inquiry.address.address = value }} type='text' />
          <div className='demande-form__city'>
            <div className='demande-form__half'>
              <Input value={stores.inquiry.address.zipCode} onChange={(value) => { stores.inquiry.address.zipCode = value }} ref='zipCode' label={t('common:fields:zip_code')} bold name='zipCode' type='text' rules={validation.zipcode} />
            </div>
            <div className='demande-form__half'>
              <Input value={stores.inquiry.address.city} onChange={(value) => { stores.inquiry.address.city = value }} ref='city' label={t('common:fields:city')} bold name='city' type='text' rules={validation.city} />
            </div>
          </div>
        </div>
        {
          this.state.errors.length
          ? <div className='form__errormessage' style={{ textAlign: 'center', marginBottom: '10px' }}>
            <b>{t('common:demande:errors:invalid_form')}</b>
            {this.state.errors ? this.state.errors.map((e, i) => <div key={i} style={{ }}>{e}</div>) : ''}
          </div> : ''
        }
        <div className='form__submit' style={{ justifyContent: 'center' }}>
          <NavigationButtons
            previous={previous}
            next={() => this.handleSubmit()} />
        </div>
      </div>
    </div>)
  }
}

AddressStepComponent.propTypes = {
  t: func,
  previous: func,
  next: func
}

export const AddressStepV2 = translate()(view(AddressStepComponent))



// WEBPACK FOOTER //
// ./src/components/inquiry/v2/AddressStepV2.js